<template>
  <div class="safeOperation">
    <div class="top_content">
      <div class="title">
        <h2>攻防演习服务</h2>
        <div class="content">
          安全运营是靠人的服务+体系化流程+智能化平台
          “三位一体”综合性解决方案，通过知己、知彼、分析、加固、事件处置动态循环持续输出价值，解决安全风险，从而实现安全的最终目标。
        </div>
      </div>
    </div>
    <div
      id="anchor1"
      class="conceptual_design"
    >
      <p class="title">
        演习方案设计
        <span style="color: #00c2b3"> | </span>
      </p>
      <div class="content">
        <div class="content_bg_img" />
        <div class="con1">
          <div class="con_text">
            <img
              src="@/assets/security/attackDrill/yxsj_img1.png"
              alt=""
            >
            <div class="text">
              建立快捷、有效的应急机制。
            </div>
          </div>
          <p class="title">
            应急处置
          </p>
        </div>
        <div class="con2">
          <p class="title">
            目标范围
          </p>
          <div class="con_text">
            <img
              src="@/assets/security/attackDrill/yxsj_img2.png"
              alt=""
            >
            <div class="text2">
              防守单位名称、目标系统等；
            </div>
          </div>
        </div>
        <div class="con3">
          <p class="title">
            攻击团队
          </p>
          <div class="con_text">
            <img
              src="@/assets/security/attackDrill/yxsj_img2.png"
              alt=""
            >
            <div class="text2">
              组织政治过硬、专业能力强的队伍；
            </div>
          </div>
        </div>
        <div class="con4">
          <p class="title">
            演习时间
          </p>
          <div class="con_text">
            <img
              src="@/assets/security/attackDrill/yxsj_img2.png"
              alt=""
            >
            <div class="text2">
              约定具体演习时间周期；
            </div>
          </div>
        </div>
        <div class="con5">
          <div class="con_text">
            <img
              src="@/assets/security/attackDrill/yxsj_img1.png"
              alt=""
            >
            <div class="text">
              平台、现场攻击设备、监控设备；
            </div>
          </div>
          <p class="title">
            环境部署
          </p>
        </div>
        <div class="con6">
          <div class="con_text">
            <img
              src="@/assets/security/attackDrill/yxsj_img1.png"
              alt=""
            >
            <div class="text">
              实时监测演习过程，控制演习风险；
            </div>
          </div>
          <p class="title">
            过程控制
          </p>
        </div>
      </div>
    </div>
    <div
      id="anchor2"
      class="Organizational_form"
    >
      <p class="title">
        攻防演习组织形式
        <span style="color: #00c2b3"> | </span>
      </p>
      <div class="content">
        <div class="content_bg_img" />
        <div class="con1">
          <div class="con_text">
            <img
              src="@/assets/security/attackDrill/zzxs3.png"
              alt=""
            >
            <div class="text2">
              成立若干攻击小组，以竞赛或合作的方式展开真实的网络攻击，发现安全漏洞，获得服务器权限。
            </div>
          </div>
          <p class="title">
            攻击队
          </p>
        </div>
        <div class="con2">
          <p class="title">
            组织单位
          </p>
          <div class="con_text">
            <img
              src="@/assets/security/attackDrill/zzxs1.png"
              alt=""
            >
            <div class="text2">
              主办：总体把控、资源协调、专家把控、裁判打分、应急响应。
            </div>
          </div>
        </div>
        <div class="con3">
          <p class="title">
            防守单位
          </p>
          <div class="con_text">
            <img
              src="@/assets/security/attackDrill/zzxs2.png"
              alt=""
            >
            <div class="text2">
              成立应急响应小组，实时监控网络，进行实时阻断，应急响应等工作。
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      id="anchor3"
      class="process_con"
    >
      <p class="title">
        服务流程
        <span style="color: #00c2b3"> | </span>
      </p>
      <div class="process">
        <div class="top_left_bg" />
        <div class="top_right_bg" />
        <div class="top_bottom_bg" />
        <div class="lists">
          <div
            v-for="item in fwlcList"
            :key="item.id"
            class="list"
          >
            <div class="item_list">
              <div class="item_list_title">
                <p>{{ item.title }}</p>
              </div>
              <div class="content">
                <div v-if="item.content != ''">
                  {{ item.content }}
                </div>
                <div v-if="item.list.length != 0">
                  <li
                    v-for="(i, index) in item.list"
                    :key="index"
                  >
                    {{ i }}
                  </li>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      id="anchor4"
      class="exercise_value"
    >
      <p class="title">
        攻防演习价值
        <span style="color: #00c2b3"> | </span>
      </p>
      <div class="content">
        <div class="content_bg">
          <div class="content_left">
            <div class="p">
              组织单位
            </div>
            <img
              src="@/assets/security/attackDrill/yxjz1.png"
              alt=""
            >
            <div class="box_show">
              <li class="border_bottom">
                监管机构：网络安全监管的有效手段，传统监督检查基础上的实战性检验，真实反应所辖区域的真实安全状态。
              </li>
              <li class="border_bottom">
                通过真实的攻击，有效的发现重保单位的互联网及内网的安全问题，通过多种攻击手段进行实践。
              </li>
              <li>
                传统渗透测试只体现单点漏洞，不能直观体现漏洞可造成的风险，实战演习直接体现漏洞所造成的侵害。（比如：可获取某单位90万用户数据、可通过某漏洞及弱口令控制服务器区所有设备……）。
              </li>
            </div>
          </div>
          <div class="content_right">
            <div class="p">
              防守单位
            </div>
            <img
              src="@/assets/security/attackDrill/yxjz2.png"
              alt=""
            >
            <div class="box_show">
              <li class="border_bottom">
                借全面评估出自己单位的安全短板，在发现安全漏洞的基础上，了解可能漏洞可能造成的侵害，提高安全认知。
              </li>
              <li class="border_bottom">
                通过外网的攻击和资产发现，也能发现本单位在互联网上暴露的危险资产。
              </li>
              <li>很好的检验安全防护能力和运维及主管人员的应急响应能力。</li>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AttackDrill',
  data() {
    return {
      fwlcList: [
        {
          id: 1,
          img: require('../../assets/security/safetyTechnology/pxjz1.png'),
          title: '调研阶段',
          content: '',
          list: [
            '演习目标系统选取',
            '明确演习时间',
            '攻防演习约束条件调研',
            '攻防演习通报机制调研'
          ]
        },
        {
          id: 2,
          img: require('../../assets/security/safetyTechnology/pxjz2.png'),
          title: '准备阶段',
          content: '',
          list: ['巡检人员对信息系统进行巡检，遇到问题，现场处理，截图留档', '攻防演习平台搭建', '签署演习授权', '签署保密协议']
        },
        {
          id: 3,
          img: require('../../assets/security/safetyTechnology/pxjz3.png'),
          title: '演习阶段',
          content: '',
          list: [
            '攻防演习过程监控',
            '攻防演习成果提交',
            '演习过程应急处置',
            '对上报结果进行研判'
          ]
        },
        {
          id: 4,
          img: require('../../assets/security/safetyTechnology/pxjz3.png'),
          title: '总结阶段',
          content: '',
          list: [
            '演习资源回收',
            '攻击数据总结',
            '对结果溯源审计',
            '总结报告并汇报',
            '下发并整改'
          ]
        }
      ]
    }
  },
  created() {
    if (this.$route.query.anchor) {
      setTimeout(() => {
        this.goAnchor(this.$route.query.anchor)
      }, 500)
    }
  },
  methods: {
    goAnchor(selector) {
      document.querySelector(selector).scrollIntoView({
        top: 500,
        behavior: 'smooth'
      })
    }
  }
}
</script>
<style lang="less" scoped>
.safeOperation {
  width: 100%;
  min-width: 1300px;

  .top_content {
    background-image: url('../../assets/security/risk/topbg.png');
    background-size: 100% 100%;
    min-height: 400px;
    margin-top: -20px;

    .title {
      width: 35%;
      margin-left: 15%;
      padding-top: 100px;
      font-size: 16px;

      .content {
        line-height: 30px;
        color: #333;
      }
    }
  }

  #anchor1,
  #anchor2,
  #anchor3 {
    padding-top: 50px;
  }

  .conceptual_design {
    width: 100%;

    .title {
      width: 80%;
      margin: 0 auto;
      font-size: 20px;
      padding-top: 40px;
      margin-bottom: 20px;
    }

    .content {
      width: 80%;
      margin: 0 auto;

      .content_bg_img {
        background-image: url('../../assets/security/attackDrill/yxsj_bg.png');
        background-size: 100% 100%;
        width: 500px;
        height: 500px;
        margin: 0 auto;
      }

      position: relative;

      img {
        width: 350px;
        height: 5px;
        margin: 0 10px;
      }

      .con_text {
        text-align: center;

        .text {
          margin-right: 40px;
        }

        .text2 {
          margin-left: 40px;
        }
      }

      .title {
        font-size: 24px;
        font-weight: bold;
        display: inline-block;
        width: 50px;
        color: #fff;
      }

      .con1 {
        position: absolute;
        top: 10%;
        left: 16%;
        display: flex;
        align-items: center;
      }

      .con2 {
        position: absolute;
        top: 0%;
        left: 52%;
        display: flex;
        align-items: center;
      }

      .con3 {
        position: absolute;
        top: 29%;
        left: 60%;
        display: flex;
        align-items: center;
      }

      .con4 {
        position: absolute;
        top: 62%;
        left: 57%;
        display: flex;
        align-items: center;
      }

      .con5 {
        position: absolute;
        top: 72%;
        left: 22%;
        display: flex;
        align-items: center;
      }

      .con6 {
        position: absolute;
        top: 43%;
        left: 13%;
        display: flex;
        align-items: center;
      }

      @media (min-width: 0) and (max-width: 1300px) {
        .con1 {
          position: absolute;
          top: 10%;
          left: 0%;
          display: flex;
          align-items: center;
        }

        .con2 {
          position: absolute;
          top: 0%;
          left: 52%;
          display: flex;
          align-items: center;
        }

        .con3 {
          position: absolute;
          top: 28%;
          left: 65%;
          display: flex;
          align-items: center;
        }

        .con4 {
          position: absolute;
          top: 61%;
          left: 60%;
          display: flex;
          align-items: center;
        }

        .con5 {
          position: absolute;
          top: 72%;
          left: 8%;
          display: flex;
          align-items: center;
        }

        .con6 {
          position: absolute;
          top: 43%;
          left: -4%;
          display: flex;
          align-items: center;
        }
      }

      @media (min-width: 1300px) and (max-width: 1400px) {
        .con1 {
          position: absolute;
          top: 10%;
          left: 0%;
          display: flex;
          align-items: center;
        }

        .con2 {
          position: absolute;
          top: 0%;
          left: 52%;
          display: flex;
          align-items: center;
        }

        .con3 {
          position: absolute;
          top: 28%;
          left: 65%;
          display: flex;
          align-items: center;
        }

        .con4 {
          position: absolute;
          top: 61%;
          left: 60%;
          display: flex;
          align-items: center;
        }

        .con5 {
          position: absolute;
          top: 72%;
          left: 8%;
          display: flex;
          align-items: center;
        }

        .con6 {
          position: absolute;
          top: 43%;
          left: -4%;
          display: flex;
          align-items: center;
        }
      }

      @media (min-width: 1400px) and (max-width: 1500px) {
        .con1 {
          position: absolute;
          top: 10%;
          left: 3%;
          display: flex;
          align-items: center;
        }

        .con2 {
          position: absolute;
          top: 0%;
          left: 51%;
          display: flex;
          align-items: center;
        }

        .con3 {
          position: absolute;
          top: 27%;
          left: 63%;
          display: flex;
          align-items: center;
        }

        .con4 {
          position: absolute;
          top: 61%;
          left: 59%;
          display: flex;
          align-items: center;
        }

        .con5 {
          position: absolute;
          top: 72%;
          left: 11%;
          display: flex;
          align-items: center;
        }

        .con6 {
          position: absolute;
          top: 43%;
          left: 0%;
          display: flex;
          align-items: center;
        }
      }

      @media (min-width: 1500px) and (max-width: 1600px) {
        .con1 {
          position: absolute;
          top: 10%;
          left: 7%;
          display: flex;
          align-items: center;
        }

        .con2 {
          position: absolute;
          top: 0%;
          left: 51%;
          display: flex;
          align-items: center;
        }

        .con3 {
          position: absolute;
          top: 28%;
          left: 62%;
          display: flex;
          align-items: center;
        }

        .con4 {
          position: absolute;
          top: 61%;
          left: 58%;
          display: flex;
          align-items: center;
        }

        .con5 {
          position: absolute;
          top: 72%;
          left: 14%;
          display: flex;
          align-items: center;
        }

        .con6 {
          position: absolute;
          top: 43%;
          left: 4%;
          display: flex;
          align-items: center;
        }
      }

      @media (min-width: 1600px) and (max-width: 1800px) {
        .con1 {
          position: absolute;
          top: 10%;
          left: 11%;
          display: flex;
          align-items: center;
        }

        .con2 {
          position: absolute;
          top: 0%;
          left: 51%;
          display: flex;
          align-items: center;
        }

        .con3 {
          position: absolute;
          top: 28%;
          left: 62%;
          display: flex;
          align-items: center;
        }

        .con4 {
          position: absolute;
          top: 61%;
          left: 58%;
          display: flex;
          align-items: center;
        }

        .con5 {
          position: absolute;
          top: 72%;
          left: 18%;
          display: flex;
          align-items: center;
        }

        .con6 {
          position: absolute;
          top: 43%;
          left: 7%;
          display: flex;
          align-items: center;
        }
      }
    }
  }

  .Organizational_form {
    width: 100%;

    .title {
      width: 80%;
      margin: 0 auto;
      font-size: 20px;
      padding-top: 40px;
      margin-bottom: 20px;
    }

    .content {
      width: 80%;
      margin: 0 auto;

      .content_bg_img {
        background-image: url('../../assets/security/attackDrill/zzxs.png');
        background-size: 100% 100%;
        width: 500px;
        height: 600px;
        margin: 0 auto;
      }

      position: relative;

      img {
        width: 400px;
        height: auto;
        margin: 0 10px;
        margin-left: 30px;
      }

      .con_text {
        width: 300px;

        .text {
          margin-right: 40px;
        }

        .text2 {
          width: 200px;
          display: flex;
          justify-content: flex-end;
          margin-top: -20px;
          margin-left: 120px;
        }
      }

      .title {
        font-size: 24px;
        font-weight: bold;
        display: inline-block;
        width: 50px;
        color: #fff;
        margin-right: 30px;
      }

      .con1 {
        position: absolute;
        top: 32%;
        left: 7.5%;
        display: flex;
        align-items: center;
        text-align: center;

        .title {
          font-size: 24px;
          font-weight: bold;
          display: inline-block;
          width: 50px;
          color: #fff;
          margin-top: 45px;
        }

        img {
          width: 400px;
          height: auto;
          margin: 0 10px;
          margin-right: 180px;
        }

        .con_text {
          width: 300px;
          margin-right: 180px;

          .text2 {
            width: 200px;
            margin-top: -80px;
          }
        }
      }

      .con2 {
        position: absolute;
        top: 2%;
        left: 48.5%;
        display: flex;
        align-items: center;
      }

      .con3 {
        position: absolute;
        top: 38%;
        left: 57.5%;
        display: flex;
        align-items: center;
      }

      @media (min-width: 0) and (max-width: 1300px) {
        img {
          width: 400px;
          height: auto;
          margin: 0 10px;
          margin-left: 40px;
        }

        .con1 {
          position: absolute;
          top: 35%;
          left: -12%;
          display: flex;
          align-items: center;
          text-align: center;

          .title {
            font-size: 24px;
            font-weight: bold;
            display: inline-block;
            width: 50px;
            color: #fff;
            margin-top: 20px;
          }

          img {
            width: 300px;
            height: auto;
            margin: 0 10px;
            margin-left: 115px;
            margin-top: -80px;
          }

          .con_text {
            width: 300px;
            margin-right: 180px;

            .text2 {
              width: 200px;
              margin-top: -50px;
            }
          }
        }

        .con2 {
          position: absolute;
          top: 2%;
          left: 48%;
          display: flex;
          align-items: center;
        }

        .con3 {
          position: absolute;
          top: 38%;
          left: 61%;
          display: flex;
          align-items: center;
        }
      }

      @media (min-width: 1300px) and (max-width: 1400px) {
        img {
          width: 400px;
          height: auto;
          margin: 0 10px;
          margin-left: 40px;
        }

        .con1 {
          position: absolute;
          top: 35%;
          left: -8%;
          display: flex;
          align-items: center;
          text-align: center;

          .title {
            font-size: 24px;
            font-weight: bold;
            display: inline-block;
            width: 50px;
            color: #fff;
            margin-top: 20px;
          }

          img {
            width: 300px;
            height: auto;
            margin: 0 10px;
            margin-left: 100px;
            margin-top: -80px;
          }

          .con_text {
            width: 300px;
            margin-right: 150px;

            .text2 {
              width: 200px;
              margin-top: -50px;
            }
          }
        }

        .con2 {
          position: absolute;
          top: 2%;
          left: 48%;
          display: flex;
          align-items: center;
        }

        .con3 {
          position: absolute;
          top: 38%;
          left: 61%;
          display: flex;
          align-items: center;
        }
      }

      @media (min-width: 1400px) and (max-width: 1500px) {
        img {
          width: 400px;
          height: auto;
          margin: 0 10px;
          margin-left: 30px;
        }

        .con1 {
          position: absolute;
          top: 35%;
          left: -4%;
          display: flex;
          align-items: center;
          text-align: center;

          .title {
            font-size: 24px;
            font-weight: bold;
            display: inline-block;
            width: 50px;
            color: #fff;
            margin-top: 20px;
          }

          img {
            width: 300px;
            height: auto;
            margin: 0 10px;
            margin-left: 100px;
            margin-top: -80px;
          }

          .con_text {
            width: 300px;
            margin-right: 150px;

            .text2 {
              width: 200px;
              margin-top: -50px;
            }
          }
        }

        .con2 {
          position: absolute;
          top: 2%;
          left: 48.5%;
          display: flex;
          align-items: center;
        }

        .con3 {
          position: absolute;
          top: 38%;
          left: 60.5%;
          display: flex;
          align-items: center;
        }
      }

      @media (min-width: 1500px) and (max-width: 1600px) {
        img {
          width: 400px;
          height: auto;
          margin: 0 10px;
          margin-left: 30px;
        }

        .con1 {
          position: absolute;
          top: 35%;
          left: -2%;
          display: flex;
          align-items: center;
          text-align: center;

          .title {
            font-size: 24px;
            font-weight: bold;
            display: inline-block;
            width: 50px;
            color: #fff;
            margin-top: 20px;
          }

          img {
            width: 300px;
            height: auto;
            margin: 0 10px;
            margin-left: 100px;
            margin-top: -80px;
          }

          .con_text {
            width: 300px;
            margin-right: 150px;

            .text2 {
              width: 200px;
              margin-top: -50px;
            }
          }
        }

        .con2 {
          position: absolute;
          top: 2%;
          left: 48.5%;
          display: flex;
          align-items: center;
        }

        .con3 {
          position: absolute;
          top: 38%;
          left: 60.5%;
          display: flex;
          align-items: center;
        }
      }

      @media (min-width: 1600px) and (max-width: 1800px) {
        img {
          width: 400px;
          height: auto;
          margin: 0 10px;
          margin-left: 30px;
        }

        .con1 {
          position: absolute;
          top: 35%;
          left: 3%;
          display: flex;
          align-items: center;
          text-align: center;

          .title {
            font-size: 24px;
            font-weight: bold;
            display: inline-block;
            width: 50px;
            color: #fff;
            margin-top: 20px;
          }

          img {
            width: 300px;
            height: auto;
            margin: 0 10px;
            margin-left: 100px;
            margin-top: -80px;
          }

          .con_text {
            width: 300px;
            margin-right: 150px;

            .text2 {
              width: 200px;
              margin-top: -50px;
            }
          }
        }

        .con2 {
          position: absolute;
          top: 2%;
          left: 48.5%;
          display: flex;
          align-items: center;
        }

        .con3 {
          position: absolute;
          top: 38%;
          left: 59%;
          display: flex;
          align-items: center;
        }
      }
    }
  }

  .process_con {
    width: 100%;
    margin-top: -100px;

    .title {
      width: 80%;
      margin: 0 auto;
      font-size: 20px;
      padding-top: 10px;
    }

    .process {
      width: 80%;
      background: -webkit-linear-gradient(#d2e4fe, #f2f2f2);
      background: -o-linear-gradient(#d2e4fe, #f2f2f2);
      background: -moz-linear-gradient(#d2e4fe, #f2f2f2);
      background: linear-gradient(#d2e4fe, #f2f2f2);
      margin: 0 auto;
      position: relative;

      .top_left_bg {
        position: absolute;
        top: -30px;
        left: 31%;
        background: -webkit-linear-gradient(#fff, #dfeaf9);
        background: -o-linear-gradient(#fff, #dfeaf9);
        background: -moz-linear-gradient(#fff, #dfeaf9);
        background: linear-gradient(#fff, #dfeaf9);
        transform: skew(-20deg);
        width: 70px;
        height: 200px;
        opacity: 0.8;
      }

      .top_right_bg {
        position: absolute;
        top: -30px;
        left: 76%;
        background: -webkit-linear-gradient(#fff, #dfeaf9);
        background: -o-linear-gradient(#fff, #dfeaf9);
        background: -moz-linear-gradient(#fff, #dfeaf9);
        background: linear-gradient(#fff, #dfeaf9);
        transform: skew(-20deg);
        width: 70px;
        height: 300px;
        opacity: 0.8;
      }

      .top_bottom_bg {
        position: absolute;
        bottom: -30px;
        left: 48%;
        background: -webkit-linear-gradient(#dfeaf9, #fff);
        background: -o-linear-gradient(#dfeaf9, #fff);
        background: -moz-linear-gradient(#dfeaf9, #fff);
        background: linear-gradient(#dfeaf9, #fff);
        transform: skew(-20deg);
        width: 70px;
        height: 300px;
        // opacity: 0.8;
      }

      .lists {
        width: 80% !important;
        margin: 0 auto;
        margin-top: 30px;
        display: flex;
        justify-content: space-around;
        flex-wrap: wrap;
        padding: 50px 0;

        .list {
          border-bottom: 5px solid #3385fb;
          width: 23%;
          min-width: 250px;
          margin-top: 30px;
          transform: skew(-20deg);
          background: -webkit-linear-gradient(#dce6f6, #fff);
          background: -o-linear-gradient(#dce6f6, #fff);
          background: -moz-linear-gradient(#dce6f6, #fff);
          background: linear-gradient(#dce6f6, #fff);

          .item_list {
            .item_list_title {
              text-align: center;
              padding: 10px;
              border-left: 10px solid #3385fb;
              background: #fff;
              box-shadow: 1px 10px 10px #dce6f6;
              font-size: 20px;

              p {
                transform: skew(20deg);
              }
            }

            .content {
              transform: skew(20deg);
              line-height: 30px;
              font-size: 20px;
              width: 70%;
              color: #3a65a4;
              padding: 50px;
              padding-bottom: 50px;
            }
          }
        }
      }
    }
  }

  .exercise_value {
    width: 100%;
    margin-top: 30px;

    .title {
      width: 80%;
      margin: 0 auto;
      font-size: 20px;
      padding-top: 10px;
    }

    .content {
      width: 80%;
      margin: 0 auto;
      margin-bottom: 50px;

      .content_bg {
        width: 80%;
        margin: 0 auto;
        display: flex;
        justify-content: space-around;
        align-items: center;

        .p {
          color: #4b93fa;
          font-size: 28px;
          font-weight: bold;
          text-align: center;
          margin-bottom: 15px;
        }

        img {
          width: 100%;
          height: auto;
        }

        .box_show {
          width: 87%;
          margin: 0 auto;
          box-shadow: 1px 10px 10px #8f8686;
          border-bottom-right-radius: 20px;
          border-bottom-left-radius: 20px;
          padding: 30px 20px 20px;
          margin-top: -18px;
          font-size: 14px;
          line-height: 30px;
          min-height: 300px;
          z-index: 999;

          li {
            padding: 10px 0;
          }
        }

        .content_left {
          width: 45%;
          position: relative;

          .p {
            color: #408af4;
          }

          .border_bottom {
            border-bottom: 1px dashed #408af4;
          }
        }

        .content_right {
          width: 45%;
          position: relative;

          .p {
            color: #d8c18f;
          }

          .border_bottom {
            border-bottom: 1px dashed #d8c18f;
          }
        }
      }
    }
  }
}

@media screen and (min-width: 1200px) and (max-width: 1350px) {
  .safeOperation .exercise_value .content .content_bg .box_show {
    height: 332px;
  }

  .safeOperation .process_con .process .lists .list .item_list .content {
    font-size: 17px;
  }

  .safeOperation .process_con .process .lists {
    width: 87% !important;
  }

  .safeOperation .process_con .process .lists .list {
    min-width: 220px;
  }
}

@media screen and (min-width: 1350px) and (max-width: 1420px) {
  .safeOperation .exercise_value .content .content_bg .box_show {
    height: 332px;
  }

}

@media screen and (min-width: 1350px) and (max-width: 1500px) {
  .safeOperation .process_con .process .lists .list .item_list .content {
    font-size: 17px;
  }

  .safeOperation .process_con .process .lists {
    width: 87% !important;
  }

  .safeOperation .process_con .process .lists .list {
    min-width: 220px;
  }

}

@media screen and (min-width: 1500px) and (max-width: 1700px) {
  .safeOperation .process_con .process .lists .list .item_list .content {
    font-size: 18px;
  }

  .safeOperation .process_con .process .lists {
    width: 88% !important;
  }

}</style>
